import { assign } from 'lodash';
import valueFilters from '../valueFilters';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IStatusLogItem extends IModel {
	effectiveDate?: Date;
	status?: string;
	description?: string;
}

const statusLogItemFactory = modelFactory.createFactory<IStatusLogItem>('StatusLogItem', assign({}, model, {
	effectiveDate: {
		setFilters: valueFilters.toUtcDate
	},
	status: {
		setFilters: valueFilters.clean
	},
	description: {
		setFilters: valueFilters.clean
	}
}));

export default statusLogItemFactory;